export interface FAQItem {
  question: string;
  answer: string;
}

export const faqs: FAQItem[] = [
  {
    question: '073漫画网的韩国漫画都是无删减版本吗？',
    answer: '是的，我们平台上的所有韩国漫画均为无删减完整版。我们与韩方版权方深度合作，确保每一部漫画都原汁原味地呈现给读者，没有任何内容的裁剪或修改。您看到的就是韩国读者看到的完整版本，包括所有画面和故事情节。',
  },
  {
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是专为移动端优化的漫画阅读方式。不同于传统的翻页模式，下拉式漫画将整个章节纵向连续排列，您只需上下滑动屏幕即可流畅地阅读完整章节内容。这种方式完全消除了翻页等待时间，让阅读体验更加沉浸和顺畅。在电脑端浏览时，您也可以使用鼠标滚轮或触控板进行下拉阅读。',
  },
  {
    question: '073漫画网的韩漫资源多久更新一次？',
    answer: '我们坚持每日更新，确保追更用户能第一时间看到最新章节。大部分热门连载漫画在韩文版更新后的24-48小时内就会同步上线中文翻译版本。我们的翻译团队全天候工作，力求将最新、最热的韩漫内容呈现给每一位读者。您可以在"最近更新"板块查看每天都有哪些漫画更新了最新章节。',
  },
  {
    question: '073漫画网完全免费吗？需要注册吗？',
    answer: '完全免费！073漫画网上的所有韩国漫画均可免费阅读，无需注册登录，无需支付任何费用。我们致力于为广大韩漫爱好者打造一个零门槛的阅读平台。您打开网站即可开始阅读，没有任何隐藏消费或付费墙。我们通过广告收入维持平台运营，绝不会向读者收费。',
  },
  {
    question: '网站支持哪些设备阅读？',
    answer: '073漫画网采用响应式设计，完美支持PC电脑端、平板电脑和手机浏览器。无论您使用什么设备，都能获得流畅舒适的阅读体验。特别是在手机端，我们的下拉式漫画阅读模式专为竖屏设计，单手持握即可轻松浏览。建议使用Chrome、Safari等主流浏览器访问，获得最佳阅读效果。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过网站顶部的搜索框直接搜索漫画名称或作者名。同时，我们的分类导航页面按照热血少年、浪漫爱情、悬疑惊悚等类型进行了详细分类，您可以按类别浏览发现感兴趣的漫画。首页的"热门推荐"和"最近更新"板块也能帮助您快速找到当前最受欢迎的韩漫作品。',
  },
  {
    question: '漫画中出现加载问题怎么办？',
    answer: '如果您在阅读过程中遇到图片加载缓慢或无法显示的情况，请尝试以下操作：首先检查您的网络连接是否正常；其次尝试刷新页面；如果问题持续，可以尝试清除浏览器缓存后重新访问。我们的服务器使用了CDN加速技术，通常情况下图片加载速度很快。如遇到服务器维护等特殊情况，我们会提前在网站公告中通知。',
  },
];